// ** React Imports
import React, { Fragment, useEffect, useState } from 'react'

import Select from "react-select";
import axios from "axios";
import { FormFeedback, Label } from "reactstrap";

const AreaFilter = ({ onAreaChange, valueList, isMultiSelect = true, isLabelRequired = true, toFetchList = true, options, hiddenArea = 'Facturacion' }) => {

    const handleArea = e => {
        setAreaValue(e);
        if (e.length === 0) {
            setError("Selecciona al menos un área");
        } else {
            onAreaChange(e);
            setError("");
        }
    }

    const [areaValue, setAreaValue] = useState(null);
    const [areaList, setAreaList] = useState([]);
    const [error, setError] = useState('');

    const getAreas = async () => {
        const areasUrl = `${process.env.REACT_APP_API_URL}/areas/assigned`;
        const response = await axios.get(areasUrl);
        let areaList = response?.data.data;
        areaList = areaList.map(area => {
            return {
                value: area.id,
                label: area.name
            }
        })
        // console.log(areaList, 'areaList');
        const areas = areaList?.filter(area => (area?.label !== hiddenArea))
        setAreaList(areas || []);
    }

    useEffect(() => {
        if (valueList) {
            setAreaValue(valueList);
        } else {
            setAreaValue(null);
        }
        if (toFetchList) {
            getAreas();
        } else {
            setAreaList(options.map(area => {
                return {
                    value: area.id,
                    label: area.name
                }
            }))
        }
    }, [valueList]);


    return (
        <Fragment>

            {isLabelRequired && <Label className='me-1' for='search-input' style={{ 'minWidth': '100px', 'display': 'inline-block', textAlign: 'right' }}>
                Area
            </Label>}

            <span >
                <Select
                    className='dataTable-filter'
                    classNamePrefix='select'
                    isMulti={isMultiSelect}
                    options={areaList}
                    // theme={selectThemeColors}
                    value={areaValue}
                    onChange={handleArea}
                    placeholder='Todas'
                />
            </span>
        </Fragment>
    )
}

export default AreaFilter;